module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Vista_Aerea.57da4ea6.jpg";